import script from "./GrouperFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./GrouperFooter.vue?vue&type=script&lang=ts&setup=true"

import "./GrouperFooter.vue?vue&type=style&index=0&id=7acfb3ca&lang=scss"

const __exports__ = script;

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QSpace,QIcon,QTooltip,QForm,QBtn,QDialog,QCardSection,QCardActions});qInstall(script, 'directives', {ClosePopup});
